import {
  GET_TYPE_INVENTORY_INCIDENT_EXITO,
  GET_TYPE_INVENTORY_INCIDENT
} from '../types/typeInventoryIncidentActionsTypes'
import { TypeInventoryIncident } from '../../interfaces/Configuration/Configuration'

export type TypeInventoryIncidentAction =
  | TypeInventoryIncidentsAction
  | TypeInventoryIncidentsActionAsync

// Esto va a REDUX
export interface TypeInventoryIncidentsAction {
  type: typeof GET_TYPE_INVENTORY_INCIDENT_EXITO
  typeInventoryIncident: TypeInventoryIncident[]
  error: string | undefined
}

export const getTypeInventoryIncidentAction = (
  typeInventoryIncident: TypeInventoryIncident[],
  error?: string
): TypeInventoryIncidentsAction => {
  return {
    type: GET_TYPE_INVENTORY_INCIDENT_EXITO,
    typeInventoryIncident: typeInventoryIncident,
    error
  }
}

// Esto va a SAGA
export interface TypeInventoryIncidentsActionAsync {
  type: typeof GET_TYPE_INVENTORY_INCIDENT
}

export const getTypeInventoryIncidentActionAsync =
  (): TypeInventoryIncidentsActionAsync => {
    return {
      type: GET_TYPE_INVENTORY_INCIDENT
    }
  }
